// extracted by css-extract-rspack-plugin
export default {"cls1":"Bookmarkers-cls1_h40","cls2":"Bookmarkers-cls2_h_b Bookmarkers-cls1_h40"};